export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "http://localhost:5003";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5003";
export const CHATBOT_SCRIPT_URL = process.env.REACT_APP_CHATBOT_SCRIPT_URL || "http://127.0.0.1:5003";
export const STATIC_BASE_URL = process.env.REACT_APP_STATIC_BASE_URL || "http://127.0.0.1:5003/static";

export const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
